import log from "loglevel";
import { ErrorLog, FulfilledLog, clearErrorLog, clearFulfilledLog } from "../../app/slices/logSlice";
import { InitializeToken } from "../../models/authentication/initializeToken";
import { LogLevelName } from "../../enums/log/logLevelName";
import store from "../../app/stores/store";

export const logMiddlewareActivator = (
  initializeToken: InitializeToken | null,
  fulfilledLog?: FulfilledLog,
  errorLog?: ErrorLog
) => {
  if (initializeToken) {
    if (fulfilledLog) {
      log
        .getLogger(LogLevelName.NoConsoleInputLog)
        .info(`Logging request from ${fulfilledLog.endpointName}`, fulfilledLog.clsLog);
      store.dispatch(clearFulfilledLog());
    }
    if (errorLog) {
      log.error("Error at the async operation:", errorLog.errorMsg, errorLog.clsLog);
      store.dispatch(clearErrorLog());
    }
  }
};
